import {
  Box,
  Button,
  Drawer,
  FormControl,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import bookUrl from "../../../../api/bookUrl";

interface Column {
  id: "name" | "role";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "name", label: "Name", minWidth: 170 },

  {
    id: "role",
    label: "Density",
    minWidth: 170,
    align: "right",
    format: (value: number) => value.toFixed(2),
  },
];

interface Data {
  name: string;
  role: string;
}

function createData(name: string, role: string): Data {
  return { name, role };
}

const rows = [
  createData("India", "IN"),
  createData("India", "IN"),
  createData("India", "IN"),
  createData("India", "IN"),
  createData("India", "IN"),
  createData("India", "IN"),
];
function BookTreatment() {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [raw, setraw] = useState([]);
  const [formData, setFormData] = useState({
    treatment: "",
    description: "",
  });

  const handleClose = () => {
    setisModalOpen(false);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    bookUrl
      .get("/bookingadmin/treatment/findBookingTreatment")
      .then((response) => {
        console.log(response);
        const formattedRows = response.data.data.map((item: any) =>
          createData(item.name, item.description)
        );
        setraw(formattedRows);
      })
      .catch(console.error)
      .finally(() => {});
  }, []);

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    console.log("Form submitted:", formData);
    bookUrl
      .post("/bookingadmin/treatment/addBookingTreatment", formData)
      .then((response) => {
        console.log(response);
        
        handleClose();
      })
      .catch(console.error)
      .finally(() => {});
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClick = () => {
    setisModalOpen(true);
  };
  return (
    <Box sx={{ bgcolor: "#ffffffff", maxHeight: "100%", borderRadius: 1 }}>
      <Stack
        direction="row"
        spacing={2}
        padding={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          marginTop: "auto",
        }}
      >
        <h3>book teatment</h3>
        <Button onClick={handleClick} variant="contained">
          add
        </Button>
      </Stack>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ height: "calc(100vh - 240px)" }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {raw
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, i) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Drawer
        anchor="right"
        open={isModalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "flex-start",
            alignItems: "center",
            padding: 1,
            width: 500,
          }}
        >
          <CloseIcon onClick={handleClose} />
        </Stack>
        <FormControl onSubmit={onSubmit} component="form">
          <Stack spacing={2} padding={2}>
            <TextField
              label="treatment"
              variant="outlined"
              name="treatment"
              value={formData.treatment}
              onChange={handleInputChange}
            />
            <TextField
              label="description"
              variant="outlined"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            padding={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button onClick={handleClose} variant="contained" color="error">
              cancel
            </Button>
            <Button variant="contained" type="submit">
              Add
            </Button>
          </Stack>
        </FormControl>
      </Drawer>
    </Box>
  );
}

export default BookTreatment;
